import Vue from 'vue'
import Router from 'vue-router'
import Layout from './views/layout.vue'
import Terms from './views/terms.vue'
import EligibleProducts from './views/eligible_products.vue'
import Contact from './views/contact.vue'
import ProductRegistration from './views/product_registration.vue'
import ProductRegistrationStep1 from './views/product_registration_step_1.vue'
import ProductRegistrationStep2 from './views/product_registration_step_2.vue'
import ProductRegistrationStep3 from './views/product_registration_step_3.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'layout',
      component: Layout,
      redirect: { name: 'terms-and-conditions'},
      children: [
        {
          path: 'terms-and-conditions',
          name: 'terms-and-conditions',
          component: Terms
        },
        {
          path: 'eligible-products',
          name: 'eligible-products',
          component: EligibleProducts
        },
        {
          path: 'contact',
          name: 'contact',
          component: Contact
        },
        {
          path: 'product-registration',
          name: 'ProductRegistration',
          component: ProductRegistration
        },
        {
          path: 'product-registration/step-1',
          name: 'ProductRegistrationStep1',
          component: ProductRegistrationStep1
        },
        {
          path: 'product-registration/step-2',
          name: 'ProductRegistrationStep2',
          component: ProductRegistrationStep2
        },
        {
          path: 'product-registration/step-3',
          name: 'ProductRegistrationStep3',
          component: ProductRegistrationStep3
        }
      ]
    }
  ]
})
